module.exports = __webpack_public_path__ + "img/spot4.7855043b.png";